import moment from 'moment';

export default {
  name: 'AudioPlayerMixin.vue',
  data() {
    return {
      AP_url: null,
      AP_duration: 0,
      AP_currentTime: 0,
      AP_volume: 1,
      AP_playing: false,
      AP_loading: true,
    };
  },
  computed: {
    AP_durationText() {
      return moment.utc(this.AP_duration * 1000).format('m:ss');
    },
    AP_currentTimeText() {
      return moment.utc(this.AP_currentTime * 1000).format('m:ss');
    },
  },
  methods: {
    AP_registerAudio(blob, url) {
      this.AP_url = blob ? URL.createObjectURL(blob) : url;
      const audio = (this.AP_audio = new Audio(this.AP_url));
      audio.addEventListener('loadedmetadata', this.AP_onLoadedMetadata);
      audio.addEventListener('canplay', this.AP_onCanPlay);
      audio.addEventListener('play', this.AP_onPlay);
      audio.addEventListener('pause', this.AP_onPause);
      audio.addEventListener('ended', this.AP_onEnded);
    },

    AP_unregisterAudio() {
      this.stopListening();
      if (this.AP_url) {
        URL.revokeObjectURL(this.AP_url);
        this.AP_url = null;
      }
      const audio = this.AP_audio;
      if (audio) {
        audio.removeEventListener('loadedmetadata', this.AP_onLoadedMetadata);
        audio.removeEventListener('canplay', this.AP_onCanPlay);
        audio.removeEventListener('play', this.AP_onPlay);
        audio.removeEventListener('pause', this.AP_onPause);
        audio.removeEventListener('ended', this.AP_onEnded);
        this.AP_audio.pause();
        this.AP_audio.src = '';
        this.AP_audio = null;
      }
    },

    AP_onLoadedMetadata() {
      this.AP_duration = this.AP_audio.duration;
    },
    AP_onTimeUpdate() {
      this.AP_currentTime = this.AP_audio ? this.AP_audio.currentTime : 0;
    },
    AP_onEnded() {
      this.AP_currentTime = this.AP_audio.currentTime = 0;
      this.AP_playing = false;
    },
    startListening() {
      this.AP_audio.addEventListener('timeupdate', this.AP_onTimeUpdate);
    },
    stopListening() {
      this.AP_audio &&
        this.AP_audio.removeEventListener('timeupdate', this.AP_onTimeUpdate);
    },
    AP_onPlay() {},
    AP_onPause() {},
    AP_onCanPlay() {
      this.AP_loading = false;
    },
    AP_play() {
      this.AP_playing = true;
      this.startListening();
      this.AP_audio.play();
    },
    AP_pause() {
      this.AP_audio.pause();
      this.AP_playing = false;
      this.stopListening();
    },
    AP_togglePlay() {
      if (this.AP_audio.paused) {
        this.AP_play();
      } else {
        this.AP_pause();
      }
    },
    AP_setVolume(volume) {
      this.AP_audio.volume = this.AP_volume = volume;
    },
  },
};
